import React from 'react'

import { PhnxButton } from '@/components/01-atoms/Button/Button'
import { GoogleMap } from '@/components/maps/GoogleMap'

import { AdvisorProps } from '../Advisor/Advisor'
import styles from './Office.module.css'

export type SpecialtiesProps = {
  title: string
  href: string
}

export type LocationProps = {
  address?: string[]
  mapHref?: string
  phone?: string
}

export type AdviserProps = {
  id: number
  name: string
  uuid: string
  __typename: string
}

export type OfficeProps = {
  name: string
  phone: string
  address: string
  city: string
  postcode: string
  state: string
  country: 'AU' | 'NZ'
  mailingAddress: any
  latitude: number
  longitude: number
  officeHours: any
  relatedAdvisors: AdvisorProps[]
  seo?: string
}

export const PhnxOffice: React.FC<OfficeProps> = (props) => {
  const { address, city, country, phone, postcode, state } = props

  return (
    <div className={styles['office']}>
      <div className={styles['mapContainer']}>
        <GoogleMap lat={props.latitude} lng={props.longitude} />
      </div>
      <div className={styles['officeDetails']}>
        <div className={styles['officeInnerDetails']}>
          <h1>Findex {props.name}</h1>
          <div className={styles['info']}>
            <div className={styles['infoItem']}>
              <p className={styles['infoItemTitle']}>Office Address</p>
              <p>{address}</p>
              <p>
                {city}, {state} {postcode} {country}
              </p>
            </div>
            <div className={styles['infoItem']}>
              <p className={styles['infoItemTitle']}>Phone</p>
              <p>{phone}</p>
            </div>
            <div className={styles['infoItem']}>
              <p className={styles['infoItemTitle']}>Hours</p>
              {props.officeHours && props.officeHours}
            </div>
            <div className={styles['infoItem']}>
              <p className={styles['infoItemTitle']}>Mailing Address</p>
              {props.mailingAddress && props.mailingAddress}
            </div>
          </div>
        </div>
      </div>
      <div className={styles['officeAdvisors']}>
        <div className={styles['officeAdvisorsInner']}>
          <div className={styles.wrapper}>
            <h4>Advisers in the office</h4>
            <div className={`${styles['button']}`}>
              <PhnxButton
                type="link"
                href="/offices/search"
                label="Search other offices"
                variant="quaternary"
                size="small"
              />
            </div>
          </div>
          <div className={styles['advisors']}>
            {props.relatedAdvisors &&
              props.relatedAdvisors.map((advisor: AdvisorProps) => {
                return (
                  <div key={advisor.title} className={styles['advisor']}>
                    <div className={styles['advisorImage']}>
                      {advisor.avatar && advisor.avatar}
                      <div className={styles['button']}>
                        <PhnxButton
                          type="link"
                          href={`${advisor.link}?requestCallback=true`}
                          label="Contact Us"
                          variant="primary"
                          size="default"
                        />
                      </div>
                    </div>
                    <div className={styles['advisorContent']}>
                      <div className={styles['nameItems']}>
                        <h4>{advisor.title}</h4>
                        <h6>{advisor.role}</h6>
                      </div>
                      <div className={styles['phoneItems']}>
                        <h4>Phone</h4>
                        <a href={`tel:${phone}`}>
                          <h6>{phone}</h6>
                        </a>
                      </div>
                      <div className={styles['biography']}>
                        <h4>Biography</h4>
                        <p>{advisor?.biography}</p>
                      </div>
                      <div className={styles['specialties']}>
                        <h4>My Specialities</h4>
                        <span>
                          {advisor.specialties &&
                            advisor.specialties.length > 0 &&
                            advisor.specialties.map(
                              (specialty: SpecialtiesProps, index: number) => (
                                <React.Fragment key={specialty.title}>
                                  <a href={specialty.href}>
                                    {specialty.title}
                                    {advisor.specialties &&
                                      index < advisor.specialties.length - 1 &&
                                      ', '}
                                  </a>
                                </React.Fragment>
                              )
                            )}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}
